import { registerPlugin } from '@capacitor/core';

import type { ApplePencilPlugin } from './definitions';
import { CAPACITOR_APPLE_PENCIL_PLUGIN_NAME } from '../pluginConstants';

const ApplePencil = registerPlugin<ApplePencilPlugin>(CAPACITOR_APPLE_PENCIL_PLUGIN_NAME);

export * from './definitions';
export { ApplePencil };
